import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';

import { RdsTabulationTotalsOptionsComponent } from './tabulation-totals-options.component';

@NgModule({
  imports: [CommonModule, FlexLayoutModule, FormsModule, MatCheckboxModule],
  declarations: [RdsTabulationTotalsOptionsComponent],
  exports: [RdsTabulationTotalsOptionsComponent]
})
export class RdsTabulationTotalsOptionsModule { }

export * from './tabulation-totals-options.component';
